import React, { FC, Fragment, useMemo } from "react";
import styled, { createGlobalStyle } from "styled-components";
import { Header, Avatar, Footer, NavigationLinkProps } from "@uitk/react";
import { MenuBar } from "../MenuBar";
import "./ApplicationShellStyles.css";
import Logo from "../../svg/Logo.svg";
import { Link, Outlet, useLocation } from "react-router-dom";
import { coreData } from "@store/index";

import { anchorProperties, Button, Heading, getNativeProps } from "@uitk/react";
import { ExitToAppIcon } from "@uitk/react-icons";
import { CenteredLoadingSpinner } from "@components/loading-component";

const LogoutButton = styled.button`
    marginLeft: 10px;
    background: rgb(255, 97, 43);
    color: white;
    font-family: Arial;
    display: flex;
    padding: 1px 20px;
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
    line-height: 24px; 
    border: none; 
    display: inline-block;
    border-radius: 24px;
    align-items: center;
    text-align: center; 
    justify-content: center;
    &:hover {
      background: #ff8000;
      color: white;
      a {
        color: white;
      }
`;

const RightNavContainer = styled.div`
  display: flex;
  flex-direction: row;
  gap: 1rem;
`;

const GlobalFooter = styled.div`
  position: relative;
`;
const currentYear = new Date().getFullYear();
const linkConfig = {
  links: [
    {
      href: "https://www.optum.com/about-us.html",
      label: "About Us",
      openInNewTab: true,
    },
    {
      href: "https://www.optum.com/contact-us.html",
      label: "Contact Us",
      openInNewTab: true,
    },
    {
      href: "https://www.optum.com/more-optum-sites.html",
      label: "More Optum Sites",
      openInNewTab: true,
    },
  ],
};

const logo = (
  <img
    src="https://www.optum.com/content/dam/optum4/images/logos/optum-logo-ora-rgb1.svg"
    className="uitk-footer__logo--small uitk-footer__logo--medium uitk-footer__logo--large"
    alt="logo"
  />
);

type ApplicationShellProps = {
  logoutHandler: () => void;
};

export const ApplicationShell: React.FC<ApplicationShellProps> = ({
  logoutHandler,
}) => {
  const { userFirstName, userLastName, userRole, isLoading } = coreData();
  const location2 = useLocation().pathname;

  const regularFooter = (
      <Footer className="footerStyles">
        CPT © {currentYear} American Medical Association. All Rights Reserved
      </Footer>
  );

  const RoutableLink: FC<NavigationLinkProps> = (item) => {
    const { children, url } = item;
    const anchorProps = getNativeProps(item, anchorProperties);
    return (
      <Link to={url} {...anchorProps}>
        {url === "/logout" && <ExitToAppIcon />} {children}
      </Link>
    );
  };

  const globalNavigationConfig = {
    linkAs: RoutableLink,
    links: [
      {
        label: "Go to",
        links: [
          { label: "Pay or Deny", url: "/PayorDeny" },
          { label: "Modifier", url: "/Modifier" },
          {
            label: "Procedure Edits",
            links: [
              {
                label: "Multiple Procedure Reduction",
                url: "/MultipleProcedureReduction",
              },
              {
                label: "Procedure Invalid Gender",
                url: "/ProcedureInvalidGender",
              },
              { label: "Procedure Valid Age", url: "/ProcedureValidAge" },
              { label: "Max Frequency Per Day", url: "/MaxFrequencyPerDay" },
              { label: "Global Days", url: "/GlobalDays" },
            ],
          },
          { label: "Place of Service", url: "/PlaceofService" },
          { label: "Anesthesia", url: "/Anesthesia" },
          {
            label: "Diagnosis Edits",
            links: [
              { label: "No Primary Diagnosis", url: "/NoPrimaryDiagnosis" },
              { label: "Third Party Liability", url: "/ThirdPartyLiability" },
              {
                label: "Diagnosis Invalid Gender",
                url: "/DiagnosisInvalidGender",
              },
              { label: "Diagnosis Valid Age", url: "/DiagnosisValidAge" },
              {
                label: "Invalid Diagnosis Combination",
                url: "/InvalidDiagnosisCombination",
              },
              {
                label: "Invalid Diagnosis Modifier",
                url: "/InvalidDiagnosisModifier",
              },
              { label: "Primary Diagnosis", url: "/PrimaryDiagnosis" },
            ],
          },
          { label: "Procedure Diagnosis", url: "/ProcedureDiagnosis" },
          { label: "User Manual", url: "/Usermanual" },
          ...(userRole === "Admin"
            ? [{ label: "Administration", url: "/Administration" }]
            : []),
        ],
      },
      // {
      //   label: "Logout",
      //   url: "/logout"
      // },
      // {
      //   label: "",
      //   url: "#",
      //   customContent: avatarContent
      // },
    ],
  };

  const logoContent = (
    <React.Fragment>
      <div>
        <img src={Logo} alt="logo" />
        <div
          style={{
            color: "#002677",
            fontFamily: "Arial",
            fontSize: "20px",
            fontStyle: "normal",
            fontWeight: "700",
            lineHeight: "150%",
            marginTop: "5px",
            marginBottom: "-10px",
          }}
        >
          Edit Rationale Module
        </div>
      </div>
    </React.Fragment>
  );

  return (
    <Fragment>
      <div style={{ position: "relative" }}>
        <Header
          logoContent={logoContent}
          // globalNavigation={globalNavigationConfig}
          className="site-header"
          productName={""}
          productLink={""}
        />
        <div
          style={{
            position: "absolute",
            top: 24,
            right: 28,
            zIndex: 5000,
          }}
        >
          <Avatar
            label=""
            initials={`${userFirstName.toUpperCase()[0]}${
              userLastName.toUpperCase()[0]
            }`}
            backgroundColor="primary"
            size="m"
          />
        </div>
        <MenuBar />
        {isLoading ? <CenteredLoadingSpinner /> : null}
        <Outlet data-testid="outlet" />
        {regularFooter}
      </div>
    </Fragment>
  );
};
